import { FC, useState, useEffect } from 'react';

import styled from 'styled-components';

import { CRUISE_PAST_SEARCH } from '@constants/constants';
import { callService } from '@api/caller';
import { TourSearchViewModel, WebUrlType } from '@api/index';

import {
  BookerSearchDrawer,
  BookerSearchViewModel,
} from './common/BookerSearchDrawer';

const WhereToGoSearchContainer = styled.div`
  .react-tiny-popover-container {
    width: 570px !important;
    top: -25px !important;
  }
`;

export const CruiseTabContent: FC<{
  subtitle: string;
  onHrefUpdate?: (href: string) => void;
  onSearchCalled: () => void;
  href?: string;
  type: string;
}> = ({ subtitle, onHrefUpdate, href, onSearchCalled, type }) => {
  const [pastCruiseItems, setPastCruiseItems] = useState(
    typeof window !== 'undefined' && localStorage.getItem(CRUISE_PAST_SEARCH)
      ? JSON.parse(localStorage.getItem(CRUISE_PAST_SEARCH) || '')
      : []
  );

  const clearPastCruiseSearch = () => {
    if (typeof window !== 'undefined')
      localStorage.removeItem(CRUISE_PAST_SEARCH);
    setPastCruiseItems([]);
  };

  const removeItemFromLocalStorage = (item: BookerSearchViewModel) => {
    const newItems = pastCruiseItems.filter(
      (i: BookerSearchViewModel) => i.text !== item.text
    );

    setPastCruiseItems(newItems);
    if (typeof window !== 'undefined')
      localStorage.setItem(CRUISE_PAST_SEARCH, JSON.stringify(newItems));
  };

  // ===========================================
  // Handle save items to local storage
  // ===========================================

  const saveItems = async () => {
    if (!href || !type) return;

    let pastCruiseItems = [];

    let cruiseItems: TourSearchViewModel[] = [];
    switch (type) {
      case WebUrlType.CRUISE_PORT:
      case WebUrlType.CRUISE_THEME:
      case WebUrlType.CRUISE_REGION:
      case WebUrlType.CRUISE_CATEGORY:
      case WebUrlType.CRUISE:
        if (
          typeof window !== 'undefined' &&
          localStorage.getItem(CRUISE_PAST_SEARCH)
        ) {
          pastCruiseItems = JSON.parse(
            localStorage.getItem(CRUISE_PAST_SEARCH) || ''
          );
        }

        cruiseItems = pastCruiseItems ? [...pastCruiseItems] : [];

        if (!cruiseItems.find((i) => i.itemText === href)) {
          cruiseItems.unshift({
            id: Math.random(),
            itemText: href,
            url: href,
          });
        } else {
          const target = cruiseItems.find((i) => i.url === href);

          const targetIndex = target ? cruiseItems.indexOf(target) : -1;

          cruiseItems.splice(targetIndex, 1);
          cruiseItems.unshift({
            id: Math.random(),
            itemText: href,
            url: href,
          });
        }
        if (typeof window !== 'undefined')
          localStorage.setItem(CRUISE_PAST_SEARCH, JSON.stringify(cruiseItems));

        window.open(href, '_self');

        break;

      default:
        window.open(href, '_self');
    }
  };
  useEffect(() => {
    if (!href || !type) return;
    saveItems();
  }, [onSearchCalled]);

  return (
    <>
      <WhereToGoSearchContainer>
        <BookerSearchDrawer
          type='Cruise'
          onHrefUpdate={onHrefUpdate}
          placeholder={subtitle}
          responsiveTitle={subtitle}
          fetchItems={(param: string) => {
            return callService('CruisesService', 'searchCruise', {
              s: param || '',
            });
          }}
          history={pastCruiseItems}
          onClearClick={clearPastCruiseSearch}
          onRemoveItem={removeItemFromLocalStorage}
        />
      </WhereToGoSearchContainer>
    </>
  );
};
export default CruiseTabContent;
